module.exports = __webpack_public_path__ + "img/2.a2389f97.png";